import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { DirectivesModule } from '../../directives/module';
import { EventModule } from '../../event/module';
import { OrganisationDashboard } from './components/dashboard/component';
import { OrganisationAdminApiService } from './services/organisation-admin-api-service';
import { MaterialModule } from 'src/app/material.module';
import { OrganisationsView } from './components/organisation/view/component';
import { RouterModule } from '@angular/router';
import { CarouselImageModule } from 'src/modules/carousel-image/module';
import { OrganisationCarouselImageApiService } from './services/carousel-image-api-service';
import { LocationModule } from 'src/modules/location/module';
import { ProductInfoModule } from 'src/modules/product-info/module';
import { OrganisationImageApiService } from './services/organisation-image-api-service';
import { OrganisationsMemberList } from './components/organisation/member-list/component';
import { OrganisationsMemberOrders } from './components/organisation/member-orders/component';
import { OrganisationMemberApiService } from './services/organisation-member-api-service';
import { CreateOrgansation } from './components/organisation/create/component';
import { OrganisationsEdit } from './components/organisation/edit/component';
import { AccountCodeEdit } from './components/organisation/modals/create/component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    RouterModule,
    EventModule,
    CarouselImageModule,
    LocationModule,
    ProductInfoModule,
  ],
  declarations: [
    OrganisationDashboard,
    OrganisationsView,
    OrganisationsMemberList,
    OrganisationsMemberOrders,
    CreateOrgansation,
    OrganisationsEdit,
    AccountCodeEdit,
  ],
  providers: [
    OrganisationAdminApiService,
    OrganisationCarouselImageApiService,
    OrganisationImageApiService,
    OrganisationMemberApiService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [OrganisationDashboard],
})
export class OrganisationAdminModule {}
